import React from 'react';
import { useLanguage } from '../LanguageProvider';

export function CookiePolicy() {
  const { language } = useLanguage();
  const texts = {
    tr: {
      title: 'Gizlilik ve Çerez Politikası',
      intro:
        'Bu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") ve ilgili mevzuat kapsamında, İlimera Teknoloji Yazılım LTD. ŞTİ. ("İlimera" veya "Şirket") tarafından işletilen web sitesi ve dijital platformlarda çerez (cookie) ve benzeri teknolojiler vasıtasıyla işlenen kişisel verilere ilişkindir.',
      whatTitle: 'Çerez Nedir?',
      whatBody:
        'Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcınıza veya cihazınıza yerleştirilen küçük metin dosyalarıdır. Çerezler, site deneyiminizin iyileştirilmesi, tercihlerinizin hatırlanması, site performansının ölçümlenmesi ve güvenlik gibi amaçlarla kullanılır.',
      typesTitle: 'Kullanılan Çerez Türleri',
      types: [
        '<strong>Zorunlu Çerezler:</strong> Sitenin temel işlevleri için gereklidir. Oturumun sürdürülmesi, güvenlik ve dolandırıcılığın önlenmesi gibi amaçlarla kullanılır. Açık rızaya tabi değildir.',
        '<strong>İşlevsellik Çerezleri:</strong> Tercih ve ayarlarınızın (ör. dil, tema) hatırlanması için kullanılır.',
        '<strong>Analitik/Performans Çerezleri:</strong> Site kullanımını ölçmek ve iyileştirmek için (ör. en çok ziyaret edilen sayfalar) anonim istatistikler üretir. Bu çerezler açık rızanıza tabidir.',
        '<strong>Pazarlama/Tanıtım Çerezleri:</strong> İlgi alanlarınıza uygun içerik ve kampanyalar göstermek için kullanılabilir. Açık rızanıza tabidir.',
      ],
      purposeTitle: 'Çerezlerin Kullanım Amaçları',
      purposes: [
        'Sitenin çalışması için gerekli temel fonksiyonların sağlanması',
        'Tercihlerin hatırlanması ve kullanıcı deneyiminin iyileştirilmesi',
        'Site performansının ölçülmesi ve iyileştirilmesi',
        'Güvenliğin sağlanması ve dolandırıcılığın önlenmesi',
      ],
      thirdPartyTitle: 'Üçüncü Taraf Çerezler',
      thirdPartyBody:
        'Sitemizde Google Analytics başta olmak üzere üçüncü taraf servisler tarafından çerezler yerleştirilebilir. Üçüncü taraf çerezler, ilgili üçüncü tarafın kontrolündedir. Bu çerezler aracılığıyla toplanan veriler, ilgili tarafların gizlilik politikalarına tabidir.',
      consentTitle: 'Çerez Tercihleri ve KVKK Açık Rıza',
      consentBody:
        'Analitik ve pazarlama çerezleri açık rızanıza tabidir. Sayfa altındaki çerez banner’ı üzerinden “Kabul Et / Reddet” seçeneklerini kullanabilir; dilediğiniz zaman tercihlerinizi güncelleyebilirsiniz.',
      manageTitle: 'Çerezleri Yönetme',
      manageLead: 'Tarayıcı ayarlarınızdan çerezleri engelleyebilir veya silebilirsiniz:',
      manageList: [
        'Chrome: Settings → Privacy & Security → Cookies',
        'Safari: Preferences → Privacy → Cookies',
        'Firefox: Options → Privacy & Security → Cookies',
        'Edge: Settings → Cookies and site permissions',
      ],
      legalTitle: 'Kişisel Verilerin İşlenmesinin Hukuki Sebepleri',
      legalBody:
        'Zorunlu çerezler KVKK m.5/2 (sözleşmenin ifası, meşru menfaat, hukuki yükümlülük) kapsamında; analitik ve pazarlama çerezleri ise KVKK m.5/1 kapsamında açık rızanıza dayanılarak işlenir.',
      retentionTitle: 'Veri Saklama',
      retentionBody:
        'Çerezler; türüne göre oturum süresince veya azami 24 ay saklanır. Süre sonunda otomatik olarak silinir veya anonimleştirilir.',
      rightsTitle: 'Haklarınız',
      rightsBody:
        'KVKK m.11 kapsamındaki haklarınız (erişim, düzeltme, silme, itiraz vb.) için bizimle iletişime geçebilirsiniz.',
      contactTitle: 'İletişim',
      contactLines: [
        '<strong>Unvan:</strong> İlimera Teknoloji Yazılım LTD. ŞTİ.',
        '<strong>Web:</strong> https://www.ilimera.com',
        '<strong>E‑posta:</strong> info@ilimera.com',
        '<strong>Genel Merkez:</strong><br />Akdeniz Üniversitesi, Teknokent Uluğbey ArGe-2 No:3A/B96 Konyaaltı / ANTALYA',
        '<strong>Ar-Ge Merkezi:</strong><br />Davraz Mah. 104. Cadde No:44-A Kat:2 Ofis:13/1<br />Merkez / ISPARTA',
      ],
      disclaimer:
        'Bu metin, genel bilgilendirme amaçlıdır. Güncel mevzuat ve şirket süreçlerinize göre hukuk danışmanınızla gözden geçirmenizi öneririz.',
    },
    en: {
      title: 'Privacy and Cookie Policy',
      intro:
        'This notice explains processing of personal data via cookies and similar technologies on İlimera Teknoloji Yazılım LTD. ŞTİ. ("İlimera" or "Company") websites and digital platforms, under the Turkish Data Protection Law No. 6698 (“KVKK”) and applicable legislation.',
      whatTitle: 'What Are Cookies?',
      whatBody:
        'Cookies are small text files placed on your browser or device by websites you visit. They are used to improve your experience, remember preferences, measure performance, and support security.',
      typesTitle: 'Types of Cookies We Use',
      types: [
        '<strong>Strictly Necessary Cookies:</strong> Required for core site functions such as session continuity, security, and fraud prevention. Not subject to consent.',
        '<strong>Functionality Cookies:</strong> Remember your preferences and settings (e.g., language, theme).',
        '<strong>Analytics/Performance Cookies:</strong> Produce anonymous statistics (e.g., most visited pages) to measure and improve site usage. Subject to your consent.',
        '<strong>Marketing/Advertising Cookies:</strong> May show content and campaigns tailored to your interests. Subject to your consent.',
      ],
      purposeTitle: 'Purposes of Cookie Use',
      purposes: [
        'Ensuring essential site functions',
        'Remembering preferences and improving user experience',
        'Measuring and enhancing site performance',
        'Providing security and preventing fraud',
      ],
      thirdPartyTitle: 'Third-Party Cookies',
      thirdPartyBody:
        'Third-party services, notably Google Analytics, may place cookies on our site. These cookies are under the control of the relevant third parties, and the data collected is subject to their privacy policies.',
      consentTitle: 'Cookie Preferences and Explicit Consent',
      consentBody:
        'Analytics and marketing cookies depend on your explicit consent. You can use the cookie banner at the bottom of the page to “Accept / Reject” and update your choices anytime.',
      manageTitle: 'Managing Cookies',
      manageLead: 'You can block or delete cookies via your browser settings:',
      manageList: [
        'Chrome: Settings → Privacy & Security → Cookies',
        'Safari: Preferences → Privacy → Cookies',
        'Firefox: Options → Privacy & Security → Cookies',
        'Edge: Settings → Cookies and site permissions',
      ],
      legalTitle: 'Legal Basis for Processing',
      legalBody:
        'Strictly necessary cookies rely on KVKK Art. 5/2 (performance of contract, legitimate interest, legal obligation); analytics and marketing cookies rely on your explicit consent under KVKK Art. 5/1.',
      retentionTitle: 'Data Retention',
      retentionBody:
        'Cookies are stored during the session or up to 24 months depending on type, after which they are deleted or anonymized.',
      rightsTitle: 'Your Rights',
      rightsBody:
        'You may exercise your rights under KVKK Art. 11 (access, rectification, erasure, objection, etc.) by contacting us.',
      contactTitle: 'Contact',
      contactLines: [
        '<strong>Company:</strong> İlimera Teknoloji Yazılım LTD. ŞTİ.',
        '<strong>Web:</strong> https://www.ilimera.com',
        '<strong>Email:</strong> info@ilimera.com',
        '<strong>Head Office:</strong><br />Akdeniz Üniversitesi, Teknokent Uluğbey ArGe-2 No:3A/B96 Konyaaltı / ANTALYA',
        '<strong>R&D Center:</strong><br />Davraz Mah. 104. Cadde No:44-A Kat:2 Ofis:13/1<br />Merkez / ISPARTA',
      ],
      disclaimer:
        'This text is for general information. Please review with your legal counsel according to current legislation and your company processes.',
    },
  } as const;

  const t = texts[language] ?? texts.tr;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold mb-6">{t.title}</h1>
      <p className="text-muted-foreground mb-6">{t.intro}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">{t.whatTitle}</h2>
      <p className="mb-4">{t.whatBody}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">{t.typesTitle}</h2>
      <ul className="list-disc pl-6 space-y-2">
        {t.types.map((item, idx) => (
          <li key={idx} dangerouslySetInnerHTML={{ __html: item }} />
        ))}
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">{t.purposeTitle}</h2>
      <ul className="list-disc pl-6 space-y-2">
        {t.purposes.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">{t.thirdPartyTitle}</h2>
      <p className="mb-4">{t.thirdPartyBody}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">{t.consentTitle}</h2>
      <p className="mb-4">{t.consentBody}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">{t.manageTitle}</h2>
      <p className="mb-2">{t.manageLead}</p>
      <ul className="list-disc pl-6 space-y-1 text-sm">
        {t.manageList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">{t.legalTitle}</h2>
      <p className="mb-4">{t.legalBody}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">{t.retentionTitle}</h2>
      <p className="mb-4">{t.retentionBody}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">{t.rightsTitle}</h2>
      <p className="mb-4 text-sm">{t.rightsBody}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">{t.contactTitle}</h2>
      <div className="space-y-3 text-sm">
        {t.contactLines.map((line, idx) => (
          <div key={idx} dangerouslySetInnerHTML={{ __html: line }} />
        ))}
      </div>

      <p className="text-xs text-muted-foreground mt-8">{t.disclaimer}</p>
    </div>
  );
}
